
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { DeviceType, AppModule } from '@/store/modules/app';
import { AppMain, Navbar, Sidebar } from './components';
import ResizeMixin from './mixin/resize';

import videoCall from '@/components/videoCall/index.vue';
import { UserModule } from '@/store/modules/user';
import { PushJumpType } from '@/const';
// import { getTimSign, getSpeech } from '@/api/third';
import { neteaseImLogin, getSpeech } from '@/api/third';
import { Howl } from 'howler';
//腾讯tim停用 20251231
// import { getTIMLogin, setTIMLogin } from '@/utils/cookies';
import { getNIMLogin, setNIMLogin } from '@/utils/cookies';
import { timeago } from '@/utils';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import { V2NIMMessage } from 'nim-web-sdk-ng/dist/v2/NIM_BROWSER_SDK/V2NIMMessageService';

@Component({
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    videoCall
  }
})
export default class extends mixins(ResizeMixin) {
  private videoCallVisible = false;
  private acceptData:any = {};
  private newOrderWav=require('@/assets/wav/new_order.wav')
  private sendOrderWav=require('@/assets/wav/send_order.wav')
   private isShowLogo=false;
   created() {
     if (
     // eslint-disable-next-line no-prototype-builtins
       this.$route.query.hasOwnProperty('order_id') &&
      // eslint-disable-next-line no-prototype-builtins
      this.$route.query.hasOwnProperty('order_service_id')
     ) {
       this.videoCallVisible = true;
     }
     if (UserModule.getUserId) {
       this.isShowLogo = true
     }
     this.imLogin();
   }

   videoCallClose() {
     this.videoCallVisible = false;
   }

   /**
    *
   imLogin() {
     const _this = this as any;
     let onMessageReceived = function(event:any) {
       // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
       // event.name - TIM.EVENT.MESSAGE_RECEIVED
       // event.data - 存储 Message 对象的数组 - [Message]
       if (event.data) {
         event.data.forEach((msgData:any) => {
           if (msgData.cloudCustomData) {
             let msgContent = JSON.parse(msgData.cloudCustomData);
             _this.PushMessage(msgContent);
             // 判断订单消息推送
             let msgTitle = '订单任务消息';
             let msgContentCon = msgContent.content;
             let jumpType = parseInt(msgContent.jump_type);
             _this.showMessageDialog(msgContent);
             if (Object.values(PushJumpType).includes(jumpType)) {
               switch (jumpType) {
                 case PushJumpType.ORDERRTC_START: {
                   // 远程视频
                   let notify = _this.$notify.info({
                     title: '提示',
                     message: msgContentCon,
                     duration: 60000,
                     onClick: () => {
                       // 打开视频页面
                       _this.acceptData = msgContent;
                       _this.videoCallVisible = true;
                       notify.close();
                     }
                   });
                   break;
                 }
                 case PushJumpType.ORDER_DELAY: {
                   // 订单超时提醒
                   let notify = _this.$notify.info({
                     title: '提示',
                     message: msgContentCon,
                     duration: 60000,
                     onClick: () => {
                       notify.close();
                     }
                   });
                   break;
                 }
                 // case PushJumpType.ORDERSERVICE_HANDLE: {
                 //   let notify = _this.$notify.info({
                 //     title: '提示',
                 //     message: msgContent,
                 //     duration: 60000,
                 //     onClick: () => {
                 //       notify.close();
                 //     }
                 //   });
                 //   break;
                 // }
                 default:
                   // _this.$message(msgContent);
                   break;
               }
               if (UserModule.getUsetInfoSettings.backend_voice_push) {
                 switch (parseInt(UserModule.getUsetInfoSettings.backend_voice_push)) {
                   case 90:
                     // 关闭所有 语音即使关闭 视频通话依旧开启
                     if (jumpType === PushJumpType.ORDERRTC_START) {
                       _this.getSpeech(msgContent);
                     }
                     break;
                   case 11:
                     // 只接收新单
                     if (jumpType === PushJumpType.ORDERSERVICE_HANDLE ||
                    jumpType === PushJumpType.ORDERRTC_START) {
                       _this.getSpeech(msgContent);
                     }
                     break;
                   case 10:
                     // 接收所有
                     _this.getSpeech(msgContent);
                     break;
                 }
               }
             }
           }
         });
       }
     };
     _this.TIM.on(_this.TIM.EVENT.MESSAGE_RECEIVED, onMessageReceived);
     let onSdkReady = function(event:any) {
       // if (event) {
       //   setTIMLogin('1');
       // } else {
       //   setTIMLogin('0');
       // }
     };
     _this.TIM.on(_this.TIM.EVENT.SDK_READY, onSdkReady);
     this.$nextTick(function() {
       if (getTIMLogin() === '1') {
         return;
       }
       getTimSign({ user_id: UserModule.getUserId }).then(res => {
         // 登录注册
         let userID = '';
         if (process.env.VUE_APP_TIM === 'prod') {
           userID = UserModule.getUserId;
         } else {
           userID = UserModule.getUserId + '_demo';
         }
         _this.TIM.login({
           userID: userID,
           userSig: res.data.user_sig
         }
         ).then((res:any) => {
           if (res.errorCode === 0) {
             setTIMLogin('1');
           } else {
             setTIMLogin('0');
           }
         }).catch((err:any) => {
           let msg = err;
         });
       });
     });
   }
  */
   
   imLogin(){
     const _this = this as any;
     let onMessageReceived = function(messages: V2NIMMessage[]) {
  
       if (messages) {
        //如果长度超过 1 个 则只取第一个  最新的消息
        if (messages.length > 1) {
          messages = messages.slice(0, 1);
        }
         messages.forEach((msgData:any) => {
           if (msgData.pushConfig && msgData.pushConfig.pushPayload ) {
             let msgContent = JSON.parse(msgData.pushConfig.pushPayload).custom;
             _this.PushMessage(msgContent);
             // 判断订单消息推送
             let msgTitle = '订单任务消息';
             let msgContentCon = msgContent.content;
             let jumpType = parseInt(msgContent.jump_type);
             _this.showMessageDialog(msgContent);
             if (Object.values(PushJumpType).includes(jumpType)) {
               switch (jumpType) {
                 case PushJumpType.ORDERRTC_START: {
                   // 远程视频
                   let notify = _this.$notify.info({
                     title: '提示',
                     message: msgContentCon,
                     duration: 3000,
                     onClick: () => {
                       // 打开视频页面
                       _this.acceptData = msgContent;
                       _this.videoCallVisible = true;
                       notify.close();
                     }
                   });
                   break;
                 }
                 case PushJumpType.ORDER_DELAY: {
                   // 订单超时提醒
                   let notify = _this.$notify.info({
                     title: '提示',
                     message: msgContentCon,
                     duration: 3000,
                     onClick: () => {
                       notify.close();
                     }
                   });
                   break;
                 }
                 // case PushJumpType.ORDERSERVICE_HANDLE: {
                 //   let notify = _this.$notify.info({
                 //     title: '提示',
                 //     message: msgContent,
                 //     duration: 60000,
                 //     onClick: () => {
                 //       notify.close();
                 //     }
                 //   });
                 //   break;
                 // }
                 default:
                   // _this.$message(msgContent);
                   break;
               }
               if (UserModule.getUsetInfoSettings.backend_voice_push) {
                 switch (parseInt(UserModule.getUsetInfoSettings.backend_voice_push)) {
                   case 90:
                     // 关闭所有 语音即使关闭 视频通话依旧开启
                     if (jumpType === PushJumpType.ORDERRTC_START) {
                       _this.getSpeech(msgContent);
                     }
                     break;
                   case 11:
                     // 只接收新单
                     if (jumpType === PushJumpType.ORDERSERVICE_HANDLE ||
                    jumpType === PushJumpType.ORDERRTC_START) {
                       _this.getSpeech(msgContent);
                     }
                     break;
                   case 10:
                     // 接收所有
                     _this.getSpeech(msgContent);
                     break;
                 }
               }
             }
           }
         });
       }
     };
     _this.NIM.V2NIMMessageService.on("onReceiveMessages", onMessageReceived );

      let onNIMLoginStatus = function(event:any) {
        setNIMLogin('1');
      }
      let onNIMLoginFailed = function(event:any) {
        setNIMLogin('0');
      }
      //https://doc.yunxin.163.com/messaging2/guide/Dk1MTY4MzA?platform=client
     _this.NIM.V2NIMLoginService.on("onLoginStatus", onNIMLoginStatus);
     _this.NIM.V2NIMLoginService.on("onLoginFailed", onNIMLoginFailed)
     _this.NIM.V2NIMLoginService.on("onKickedOffline", onNIMLoginFailed)
     _this.NIM.V2NIMLoginService.on("onLoginClientChanged", onNIMLoginFailed)
     
     _this.NIM.V2NIMLoginService.on("onConnectStatus", onNIMLoginStatus)
     _this.NIM.V2NIMLoginService.on("onDisconnected", onNIMLoginFailed)
     _this.NIM.V2NIMLoginService.on("onConnectFailed", onNIMLoginFailed)

     this.$nextTick(function() {
      //  if (getNIMLogin() === '1') {
      //   alert("dsf")
      //    return;
      //  }
       neteaseImLogin({ account_id: UserModule.getUserId }).then(res => {
         // 登录注册
          if(res.data) {
            try {
                _this.NIM.V2NIMLoginService.login(res.data.account_id, res.data.token, {
                "forceMode": false
                })
            } catch (err) {
                // TODO failed, check code
                // console.log(err.code)
            }
          }
       });
     });
   
   }

   showMessageDialog(msgContent:any) {
     const h = this.$createElement;
     let showDeal = false;
     let showDetail = false;
     switch (parseInt(msgContent.jump_type)) {
       case PushJumpType.ORDERSERVICE_HANDLE:
         if (msgContent.company_id === UserModule.getCompanyId) {
           showDeal = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.ORDER_DEAL);
         }
         break
       case PushJumpType.ORDERTASK_HANDLE:
         if (msgContent.company_id === UserModule.getCompanyId) {
           showDeal = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.TASK_DEAL);
         }
         break
       case PushJumpType.ORDERSERVICE_DETAIL:
       case PushJumpType.ORDERTASK_DETAIL:
         if (msgContent.company_id === UserModule.getCompanyId) {
           showDetail = true;
         }
         break
     }
     let notify = this.$notify.info({
       title: msgContent.order_num ? msgContent.order_num : '你有一个新消息',
       message: h('span', [
         h('div', { 'class': 'text-line-2' }, msgContent.content),
         h('div', { 'class': 'clearfix' }, [
           h('div', { 'class': 'fleft' }, timeago(msgContent.msg_time)), // 时间显示
           h('div', { 'class': 'fright' }, [
             h('button', { 'class': 'el-button el-button--lightgrey el-button--mini',
               'attrs': { 'type': 'button' },
               on: {
                 click: () => {
                   notify.close()
                 }
               }
             }, '关闭'),
             (showDeal||showDetail) ? h('button', { 'class': 'el-button el-button--secondary el-button--mini',
               'attrs': { 'type': 'button' },
               on: {
                 click: () => {
                   notify.close()
                   this.toDealwithHandler(msgContent)
                 }
               },
             }, showDetail?'查看':'立即处理') : '',
           ])
         ])
       ]),
       position: 'bottom-right',
       customClass: 'message',
       duration: 3000,
       // onClick: () => {
       //   this.notifyCloseHandle();
       // }
     });
   }
   toDealwithHandler(msgContent:any) {
     switch (parseInt(msgContent.jump_type)) {
       case PushJumpType.ORDERSERVICE_HANDLE:
         this.$router.push({
           path: '/OrderServicer/todealing',
           query: { order_service_id: msgContent.order_service_id, company_id: UserModule.getCompanyId }
         });
         break
       case PushJumpType.ORDERTASK_HANDLE:
         this.$router.push({
           path: '/Task/todealing',
           query: { taskId: msgContent.order_task_id, companyId: UserModule.getCompanyId, orderType: msgContent.fix_type, enterType: '1' }
         });
         break
       case PushJumpType.ORDERSERVICE_DETAIL:
         var routeData1 = this.$router.resolve({
           path: '/OrderServicer/todetail',
           query: {
             order_service_id: msgContent.order_service_id,
             company_id: UserModule.getCompanyId,
           }
         });
         window.open(routeData1.href);
         break
       case PushJumpType.ORDERTASK_DETAIL:
         var routeData = this.$router.resolve({
           path: '/Task/todetail',
           query: {
             'taskId': msgContent.order_task.id,
             'companyId': UserModule.getCompanyId,
             'orderType': msgContent.fix_type,
             'enterType': '1',
             'isDetail': '1',

           },
         });
         window.open(routeData.href);
         break
     }
   }
   getSpeech(msgContent: any) {
     if (parseInt(msgContent.android_sound) === 1) {
       let sound = new Howl({
         // @ts-ignore
         src: [this.newOrderWav]
       });
       sound.play();
     } else if (parseInt(msgContent.android_sound) === 2) {
       let sound = new Howl({
         // @ts-ignore
         src: [this.sendOrderWav]
       });
       sound.play();
     }

     // getSpeech({ text: text }).then(res => {
     //   /*
     //       let a = new Audio();
     //       a.src = res
     //       a.play()
     //       */
     // });
   }

   get classObj() {
     return {
       hideSidebar: !this.sidebar.opened,
       openSidebar: this.sidebar.opened,
       withoutAnimation: this.sidebar.withoutAnimation,
       mobile: this.device === DeviceType.Mobile
     };
   }

   get themeClass() {
     // return AppModule.themed;
     return '';
   }

   // private handleClickOutside() {
   //   AppModule.CloseSideBar(false);
   // }

   private PushMessage(data: any) {
     AppModule.PushMessage(data);
   }
}
